import React from 'react';
import { Table } from '@zillow/constellation';

export const TableHeader: React.FC = () => {
  return (
    <Table.Header appearance="dark">
      <Table.Row>
        <Table.SortableHeaderCell id="fullName">Name</Table.SortableHeaderCell>
        <Table.SortableHeaderCell id="email">Email</Table.SortableHeaderCell>
        <Table.HeaderCell>Role</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
        <Table.HeaderCell>&nbsp;</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  );
};
